import * as React from 'react';

import Pagination from 'antd/es/pagination';

import { ItemsProvider, useItemsProviderContext, SortingDirection } from '@common/react/components/Core/ItemsProvider/ItemsProvider';
import ServerPageProvider from '@common/react/components/Core/ServerPageProvider/ServerPageProvider';
import { BreadCrumbs } from '@common/react/components/UI/BreadCrumbs/BreadCrumbs';

import { Region } from '@commonTuna/react/objects/Region';

import RegionTag from '@app/components/Pages/Region/RegionTag';

import '@app/scss/pages/catalog.scss';

const RegionList: React.FC = () => {
	const { state: { items, pagination }, actions: { handleChange } } = useItemsProviderContext<Region>();

	const onPaginationChange = (current, pageSize) => {
		handleChange({ page: current, pageSize });
	};

	return (<div className="catalog mb10">
		<ul className="catalog__list">
			{items.map((item) => <li key={item.id} className="catalog__list__item">
				<RegionTag location={item} />
			</li>)}
		</ul>
		{pagination?.total > items.length && <div className="pull-right mt10 mb10">
			<Pagination onChange={onPaginationChange} {...pagination} />
		</div>}
	</div>);
};

const Regions: React.FC = () => {
	return <>
		<ServerPageProvider
			path="locations"
			defaultTitle="Locations"
			inner={(page) => (
				<ItemsProvider<Region>
					rows={page?.items}
					loadRequest="regionList"
					filters={{ column: [{ caption: 'name', direction: SortingDirection.Ascending }] }}
					paginationUrl={{ defaultPageSize: 200 }}
					withHandleUrl
				>
					<div className="container">
						<BreadCrumbs
							title="Locations"
						/>
						<div className="site-headline site-headline_with-button clearfix">
							<h1 className="pull-left">Locations</h1>
						</div>
						<RegionList />
					</div>
				</ItemsProvider>
			)}
		/>
	</>;
};

export default Regions;
